import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

import { CORPORATE_USERNAME_PATTERN, EMAIL_PATTERN, isFinnairPlusCardNumber } from '@fcom/core/utils/utils';

/**
 * FPlus number validation without AY prefix
 */
export const finnairPlusNumberValidator = (): ValidatorFn => {
  return (control: AbstractControl): Record<string, unknown> | null => {
    if (control.value === '' || control.value === null || isFinnairPlusCardNumber(control.value.toUpperCase())) {
      return null;
    } else {
      return { pattern: true };
    }
  };
};

export const usernameValidator = (): ValidatorFn => {
  return (control: AbstractControl): Record<string, unknown> | null => {
    const invalidEmail = Validators.pattern(EMAIL_PATTERN)(control);
    const invalidMemberNumber = finnairPlusNumberValidator()(control);
    if (control.value === '' || control.value === null) {
      return null;
    } else if (invalidEmail && invalidMemberNumber) {
      return { pattern: true };
    } else {
      return null;
    }
  };
};

export const corporateUsernameValidator = (): ValidatorFn => {
  return (control: AbstractControl<string>): Record<string, boolean> | null => {
    if (!control.value) {
      return null;
    }
    const invalidEmail = Validators.pattern(EMAIL_PATTERN)(control);
    const invalidUserName = !control.value.match(CORPORATE_USERNAME_PATTERN);
    if (invalidEmail && invalidUserName) {
      return { pattern: true };
    }
    return null;
  };
};

/**
 * Validates a comma-separated list of email addresses
 * @returns ValidatorFn that returns null if valid or { pattern: true } if any email is invalid
 */
export const commaSeparatedEmailListValidator = (): ValidatorFn => {
  return (control: AbstractControl<string>): Record<string, boolean> | null => {
    const raw = (control.value ?? '').trim();
    if (!raw) {
      return null;
    }

    const emails = raw
      .split(',')
      .map((email) => email.trim())
      .filter((email) => email.length > 0);

    const emailRegex = new RegExp(EMAIL_PATTERN);
    const hasInvalid = emails.some((email) => !emailRegex.test(email));

    return hasInvalid ? { pattern: true } : null;
  };
};
